import { legacy_createStore, applyMiddleware, compose } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import appConfig from "../config/appConfig";

// Auth lives in memory + HttpOnly cookie; do not persist AuthenticationData.
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["AuthenticationData"],
};

// One-time clear of previously encrypted persist data.
const PERSIST_PLAIN_MIGRATION_KEY = "persist:plain-v1";
try {
  if (!localStorage.getItem(PERSIST_PLAIN_MIGRATION_KEY)) {
    localStorage.removeItem("persist:root");
    localStorage.setItem(PERSIST_PLAIN_MIGRATION_KEY, "1");
  }
} catch (error) {
  // ignore
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers =
  !appConfig.isProduction && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const store = legacy_createStore(persistedReducer, composeEnhancers(applyMiddleware(thunk)));
const persistor = persistStore(store);

export { store, persistor };
